import { PRICING_V4_CATALOG_ID } from "./mocks";
import { v4Number } from "./v4Explanation";
import { v4LargestPortion } from "./v4Selection";

const currencyPrecision = new Intl.NumberFormat("en-US", {
  useGrouping: false,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

export function v4UnitPrice(value) {
  const price = v4Number(value);
  if (!(price > 0)) return null;
  const displayed = Number(currencyPrecision.format(price));
  return displayed > 0 ? displayed : null;
}

export function v4UnitPriceComparison(suggestion) {
  if (suggestion?.current_price_comparison)
    return suggestion.current_price_comparison;
  const portions = suggestion?.portions;
  if (!Array.isArray(portions) || !portions.length) return null;
  const candidates = portions.map(portion => {
    const size = v4Number(portion?.portion_base);
    const current = v4Number(portion?.current_price_brl);
    const suggested = v4Number(portion?.suggested_price_brl);
    if (!(size > 0 && current > 0 && suggested > 0)) return null;
    if (!Number.isFinite(current / size) || !Number.isFinite(suggested / size))
      return null;
    return {
      ...portion,
      current_unit_price_brl: current / size,
      suggested_unit_price_brl: suggested / size
    };
  });
  if (candidates.some(value => !value)) return null;
  if (
    suggestion?.decision_contract_version ===
    "pricing-v4.live-pilot-product.v11"
  )
    return v4LargestPortion(suggestion, candidates);
  return candidates.sort(
    (a, b) =>
      a.current_unit_price_brl - b.current_unit_price_brl ||
      Number(b.portion_base) - Number(a.portion_base)
  )[0];
}

export function v4CatalogChanged(suggestion, row) {
  if (suggestion?.catalog_baseline_changed === true) return true;
  // V11 checks every package against fresh catalogs in its server preview.
  // The legacy P. Atual can refer to a different package.
  if (
    suggestion?.decision_contract_version ===
    "pricing-v4.live-pilot-product.v11"
  )
    return false;
  if (
    suggestion?.status !== "ready" ||
    Number(suggestion?.catalog_id) !== PRICING_V4_CATALOG_ID ||
    Number(suggestion?.product_base_id) !== Number(row?.product_base_id)
  )
    return false;
  const current = v4UnitPrice(row?.preco_ameixa);
  const observed = v4UnitPrice(
    v4UnitPriceComparison(suggestion)?.current_unit_price_brl
  );
  return current !== null && observed !== null && current !== observed;
}
